export enum Environment {
    PRODUCTION = "production",
    DEMO = "demo",
    DEVELOPMENT = "development",
    LOCAL = "local",
    TESTING = "testing",
    STAGING = "staging",
}

export namespace Environment {

    export function fromStr(environment: string): Environment {
        const env = environment as Environment;
        if (!env || !Object.values(Environment).includes(env)) {
            throw new Error(`Invalid environment: ${env}`);
        }
        return env;
    }
}
